import { Modal, ModalContent, ModalManager } from "../../../Modal";
import React from "react";
import { Button } from "../../../Button";
import { Box } from "../../../Box";
import { useCamera } from "../../../../hooks";

type Props = {
  show: boolean;
  onClose: () => any;
  onCaptured: (image: string) => any;
};

export const CaptureModal = ({ show, onClose, onCaptured }: Props) => {
  const { cameraRef, canvasRef, error, handleCapture } = useCamera();

  return (
    <ModalManager onClose={onClose} showModal={show}>
      <Modal fitWidth style={{ height: "auto" }}>
        <ModalContent>
          <Box flex flexDirectionColumn style={{ gap: "12px" }}>
            <canvas ref={canvasRef} style={{ display: "none" }} />
            <video
              ref={cameraRef}
              autoPlay
              playsInline
              width="600px"
              style={{ transform: "scaleX(-1)" }}
            />
            {!error && (
              <Button
                onClick={() => {
                  handleCapture((image) => {
                    onCaptured(image);
                  });
                }}
              >
                Take Selfie
              </Button>
            )}
          </Box>
        </ModalContent>
      </Modal>
    </ModalManager>
  );
};
